import React, { useState, useEffect } from 'react';
import { fetchDashboardData } from '../../services/api.js'; // Import your function
import { useNavigate } from 'react-router-dom';
import '../../styles/output.css';
import '../../styles/index.css';
import menuItems from '../SideMenu/menuItems';



import { SideMenu, Header, TopMenu } from 'maxcu-shared-lib';


function Dashboard() {
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const [isCollapsed, setIsCollapsed] = useState(false);
    
  
    useEffect(() => {
      let isMounted = true;
  
        document.title = "Add an Account | MAX Credit Union";
      const getData = async () => {
        try {
          const result = await fetchDashboardData();

          setTimeout(() => {
            if (isMounted){
              setData(result);
            }
          },500);
        } catch (err) {
          if (isMounted){
            setError(err);
          }
        }
      };
      getData();
  
      const handleResize = () => {
            if (window.innerWidth < 600) {
                setIsCollapsed(true);
            } else {
                setIsCollapsed(false);
            }
        };

        handleResize(); // Set initial state

        window.addEventListener('resize', handleResize);
        
        return () => {
            isMounted=false;
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    if (error) return <div>Error: {error.message}</div>;
    if (!data) return <div>Loading...</div>;
    return (
        <div className="min-h-screen flex flex-col">
          <SideMenu menuItems={menuItems} />
          <div style={{ flex: 1 }} className={`${isCollapsed ? 'sb-thin' : 'sb-wide'}`}>
          <Header name="Add A New Account" />
          {isCollapsed && <TopMenu />}
          <br/>
          <div className="flex-grow flex flex-col items-center justify-center space-y-4">
            {data.btn_addclub === 'YES' && (
              <button onClick={() => navigate('/addclub')} className="inline-block bg-blue-600 border border-transparent rounded-full py-1 px-6 text-sm font-bold text-white text-center hover:bg-blue-700">
                  Add a new Club Account
              </button>
            )}
            {data.btn_addchk === 'YES' && (
              <button onClick={() => navigate('/addchk')} className="inline-block bg-blue-600 border border-transparent rounded-full py-1 px-6 text-sm font-bold text-white text-center hover:bg-blue-700">
                  Add a new Spend Account
              </button>
            )}
            {data.btn_addcertificate === 'YES' && (
              <button onClick={() => navigate('/addcert')} className="inline-block bg-blue-600 border border-transparent rounded-full py-1 px-6 text-sm font-bold text-white text-center hover:bg-blue-700">
                  Add a new Certificate
              </button>
            )}
            {data.btn_addmm === 'YES' && (
              <button onClick={() => navigate('/addmm')} className="inline-block bg-blue-600 border border-transparent rounded-full py-1 px-6 text-sm font-bold text-white text-center hover:bg-blue-700">
                  Add a new Money Market
              </button>
            )}
            {data.btn_addmm === 'NO' && data.btn_addcertificate === 'NO' && data.btn_addchk === 'NO' && data.btn_addclub === 'NO' &&(
              <h1>You are currently ineligible to Add an Account at this time. Please contact us at 334.260.2600 for more assistance</h1>
            )}
          </div>
          </div>
        </div>
    );
}

export default Dashboard;

